import SEO from "@/components/SEO";
import { Reveal, LineReveal } from "@/components/Reveal";

export default function Privacy() {
  return (
    <>
      <SEO title="Privacy Policy" description="How Victory Chapel handles your information." path="/privacy" />
      <section className="grain relative overflow-hidden bg-navy py-16 text-white sm:py-24">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <LineReveal className="mt-2 font-display text-4xl font-900 tracking-tighter sm:text-6xl" lines={["PRIVACY POLICY"]} />
        </div>
      </section>
      <section className="bg-cream py-16 sm:py-20">
        <div className="mx-auto max-w-3xl space-y-8 px-5 text-base leading-relaxed text-slate-700 sm:px-8">
          <Reveal>
            <h2 className="font-display text-xl font-800 text-navy">What we collect</h2>
            <p className="mt-2">When you fill out a form on this site (Plan Your Visit, Service #1 registration, prayer request, or contact), we collect the information you provide - such as your name, email, phone number, and message - so our team can follow up with you personally.</p>
          </Reveal>
          <Reveal>
            <h2 className="font-display text-xl font-800 text-navy">How we use it</h2>
            <p className="mt-2">Your information is used only for church communication and follow-up. We never sell, rent, or share your personal information with third parties for marketing. Prayer requests marked confidential are shared only with the pastoral team.</p>
          </Reveal>
          <Reveal>
            <h2 className="font-display text-xl font-800 text-navy">Giving</h2>
            <p className="mt-2">Online giving is processed by a secure, PCI-compliant third-party provider. Victory Chapel never sees or stores your credit card information.</p>
          </Reveal>
          <Reveal>
            <h2 className="font-display text-xl font-800 text-navy">Analytics</h2>
            <p className="mt-2">We may use privacy-respecting analytics to understand how people use this site so we can serve visitors better. You can browse this site without submitting any personal information.</p>
          </Reveal>
          <Reveal>
            <h2 className="font-display text-xl font-800 text-navy">Contact</h2>
            <p className="mt-2">Questions about your information? Contact us any time through the contact page and we'll be glad to help - including removing your information on request.</p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
